import {Action} from '@ngrx/store';
import {Tenant} from '@app/core/models/tenant.model';
import {User} from '@app/core/models/user.model';
import {Department} from '@app/core/models/department.model';
import {LoginContext, UserType} from '@app/core/services/auth.service';
import {ITenantPostPayload} from '@app/modules/shared/services/tenant.service';
import {EQOHubApplication, EQOModule} from '@quickorder/angular-web-lib';
import {IQOHubChain} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-hub-chain.interface';

export enum ESessionActions {
	GetSession = '[Session] Get Session',
	GetSessionSuccess = '[Session] Get Session Success',
	SetTenant = '[Session] Set Tenant',
	RegisterTenant = '[Session] Register Tenant',
	RegisterTenantSuccess = '[Session] Register Tenant Success',
	GetDepartments = '[Session] Get Departments',
	GetDepartmentsSuccess = '[Session] Get Departments Success',
	GetTenants = '[Session] Get Tenants',
	GetTenantsSuccess = '[Session] Get Tenants Success',
	ClearTenants = '[Session] Clear Tenants',
	SetUser = '[Session] Set User',
	SetDepartment = '[Session] Set Department',
	SetDepartments = '[Session] Set Departments',
	SwitchDepartment = '[Session] Switch Department',
	SwitchDepartmentSuccess = '[Session] Switch Department Success',
	SetNewPassword = '[Session] Set New Password',
	SetNewPasswordSuccess = '[Session] Set New Password Success',
	PunchLogin = '[Session] Punch Login',
	PunchLoginSuccess = '[Session] Punch Login Success',
	SetUserType = '[Session] Set User Type',
	SetNewUser = '[Session] Set New User',
	SetNewUserSuccess = '[Session] Set New User Success',
	SendForgotPassword = '[Session] Send Forgot Password',
	SendForgotPasswordSuccess = '[Session] Send Forgot Password Success',
	Login = '[Session] Login',
	LoginSuccess = '[Session] Login Success',
	ClearSession = '[Session] Clear Session',
	ClearSessionSuccess = '[Session] Clear Session Success',
	PunchLogout = '[Session] Punch Logout',

	SaveUserProfile = '[Session] Save User Profile',

	UpdateCurrentUser = '[Session] Update Current User',

	SubscribeWebPushNotifications = '[Session] Subscribe Web Push Notifications',
	UnsubscribeWebPushNotifications = '[Session] Unsubscribe Web Push Notifications',

	// qo-hub
	GetHubChain = '[Auth] Get Hub Chain',
	GetHubChainSuccess = '[Auth] Get Hub Chain Success',

	NavigateToModule = '[Auth] Navigate To Module',

	GenerateTokenAndNavigateToModule = '[Auth] Generate Token And Navigate To Module',
	GenerateTokenAndNavigateToModuleSuccess = '[Auth] Generate Token And Navigate To Module Success',
	GetTenantsList = '[Session] Get Tenants List',
	GetTenantsListSuccess = '[Session] Get Tenants List Success',
}

export class NavigateToModule implements Action {
	public readonly type = ESessionActions.NavigateToModule;

	constructor(
		public module: EQOModule,
	) {}
}

export class GenerateTokenAndNavigateToModule implements Action {
	public readonly type = ESessionActions.GenerateTokenAndNavigateToModule;

	constructor(
		public application: EQOHubApplication,
		public tenantId: number,
	) {}
}

export class GenerateTokenAndNavigateToModuleSuccess implements Action {
	public readonly type = ESessionActions.GenerateTokenAndNavigateToModuleSuccess;

	constructor() {}
}

export class GetHubChain implements Action {
	public readonly type = ESessionActions.GetHubChain;

	constructor() {}
}

export class GetHubChainSuccess implements Action {
	public readonly type = ESessionActions.GetHubChainSuccess;

	constructor(
		public hub_chain: IQOHubChain,
	) {}
}

export class SetTenant implements Action {
	public readonly type = ESessionActions.SetTenant;

	constructor(public tenant: Tenant) {
	}
}

export class ClearTenants implements Action {
	public readonly type = ESessionActions.ClearTenants;

	constructor() {
	}
}

export class RegisterTenant implements Action {
	public readonly type = ESessionActions.RegisterTenant;

	constructor(public payload: ITenantPostPayload) {
	}
}

export class RegisterTenantSuccess implements Action {
	public readonly type = ESessionActions.RegisterTenantSuccess;

	constructor() {
	}
}

export class GetDepartments implements Action {
	public readonly type = ESessionActions.GetDepartments;

	constructor() {
	}
}

export class GetDepartmentsSuccess implements Action {
	public readonly type = ESessionActions.GetDepartmentsSuccess;

	constructor(public departments: Department[]) {
	}
}

export class GetTenants implements Action {
	public readonly type = ESessionActions.GetTenants;

	constructor(
		public email: string,
		public password: string,
	) {
	}
}

export class GetTenantsSuccess implements Action {
	public readonly type = ESessionActions.GetTenantsSuccess;

	constructor(public tenants: Tenant[]) {
	}
}

export class GetTenantsList implements Action {
	public readonly type = ESessionActions.GetTenantsList;

	constructor(
		public email: string,
	) {
	}
}

export class GetTenantsListSuccess implements Action {
	public readonly type = ESessionActions.GetTenantsListSuccess;

	constructor(public tenants: Tenant[]) {
	}
}

export class SetUser implements Action {
	public readonly type = ESessionActions.SetUser;

	constructor(public user: User) {
	}
}

export class SetDepartment implements Action {
	public readonly type = ESessionActions.SetDepartment;

	constructor(public department: Department) {
	}
}

export class SetDepartments implements Action {
	public readonly type = ESessionActions.SetDepartments;

	constructor(public departments: Department[]) {
	}
}

export class GetSession implements Action {
	public readonly type = ESessionActions.GetSession;

	constructor() {
	}
}

export class SetNewPassword implements Action {
	public readonly type = ESessionActions.SetNewPassword;

	constructor(
		public email: string,
		public token: string,
		public password: string,
	) {
	}
}

export class SetNewPasswordSuccess implements Action {
	public readonly type = ESessionActions.SetNewPasswordSuccess;

	constructor() {
	}
}

export class PunchLogin implements Action {
	public readonly type = ESessionActions.PunchLogin;

	constructor(
		public tenant_id: number,
		public department_id: number,
		public password: string,
	) {
	}
}

export class PunchLoginSuccess implements Action {
	public readonly type = ESessionActions.PunchLoginSuccess;

	constructor() {
	}
}

export class SetNewUser implements Action {
	public readonly type = ESessionActions.SetNewUser;

	constructor(
		public email: string,
		public password: string,
		public sign_up_token: string,
		public phone_number: number,
		public birth_date: string,
		public phone_ext: string,
		public language_id: number,
	) {
	}
}

export class SetNewUserSuccess implements Action {
	public readonly type = ESessionActions.SetNewUserSuccess;

	constructor() {
	}
}

export class SendForgotPassword implements Action {
	public readonly type = ESessionActions.SendForgotPassword;

	constructor(
		public email: string,
	) {
	}
}

export class SendForgotPasswordSuccess implements Action {
	public readonly type = ESessionActions.SendForgotPasswordSuccess;

	constructor() {
	}

}

export class GetSessionSuccess implements Action {
	public readonly type = ESessionActions.GetSessionSuccess;

	constructor(
		public user: User,
		public department: Department,
		public departments: Department[],
	) {
	}
}

export class SwitchDepartment implements Action {
	public readonly type = ESessionActions.SwitchDepartment;

	constructor(public departmentId: number) {
	}
}

export class SwitchDepartmentSuccess implements Action {
	public readonly type = ESessionActions.SwitchDepartmentSuccess;

	constructor() {
	}
}

export class Login implements Action {
	public readonly type = ESessionActions.Login;

	constructor(
		public login: LoginContext,
		public selectedTenant: Tenant,
	) {
	}
}

export class LoginSuccess implements Action {
	public readonly type = ESessionActions.LoginSuccess;

	constructor() {
	}
}

export class ClearSession implements Action {
	public readonly type = ESessionActions.ClearSession;

	constructor() {
	}
}

export class ClearSessionSuccess implements Action {
	public readonly type = ESessionActions.ClearSessionSuccess;

	constructor() {
	}
}

export class PunchLogout implements Action {
	public readonly type = ESessionActions.PunchLogout;

	constructor() {
	}
}

export class SaveUserProfile implements Action {
	public readonly type = ESessionActions.SaveUserProfile;

	constructor(public data: any, public emailChanged: boolean) {
	}
}

export class UpdateCurrentUser implements Action {
	public readonly type = ESessionActions.UpdateCurrentUser;

	constructor(public user: User) {
	}
}

export class SetUserType implements Action {
	public readonly type = ESessionActions.SetUserType;

	constructor(public userType: UserType) {
	}
}

export class SubscribeWebPushNotifications implements Action {
	public readonly type = ESessionActions.SubscribeWebPushNotifications;

	constructor() {
	}
}

export class UnsubscribeWebPushNotifications implements Action {
	public readonly type = ESessionActions.UnsubscribeWebPushNotifications;

	constructor() {
	}
}

export type SessionActions =
	GetSession |
	GetSessionSuccess |
	SetTenant |
	SetUser |
	SetDepartment |
	SetDepartments |
	SwitchDepartment |
	SetNewPassword |
	SetNewPasswordSuccess |
	PunchLogin |
	PunchLoginSuccess |
	SetNewUser |
	SetNewUserSuccess |
	SendForgotPassword |
	SendForgotPasswordSuccess |
	GetDepartments |
	GetDepartmentsSuccess |
	GetTenants |
	GetTenantsSuccess |
	SwitchDepartmentSuccess |
	Login |
	LoginSuccess |
	ClearSession |
	ClearSessionSuccess |
	PunchLogout |
	SaveUserProfile |
	UpdateCurrentUser |
	SetUserType |
	SubscribeWebPushNotifications |
	UnsubscribeWebPushNotifications |
	RegisterTenant |
	RegisterTenantSuccess |
	ClearTenants |
	GetHubChain |
	GetHubChainSuccess |
	GenerateTokenAndNavigateToModule |
	GenerateTokenAndNavigateToModuleSuccess |
	NavigateToModule |
	GetTenantsList |
	GetTenantsListSuccess
	;
